<template>
    <transition
        v-on:enter="enterMain"
        v-on:leave="leaveMain"
    >
    <div class="nav z-100 active" v-if="show">
        <div class="z-50 fixed top-0 left-0 mt-5 ml-5 w-16 md:w-24">
            <a href="/">
            <img src="/img/branding/siobhan-cooney-logo.png" class="w-full" alt="Siobhan Cooney Logo">
            </a>
        </div>

        <div class="fixed top-0 right-0 mt-10 mr-8 w-8">
            <main-nav-toggle class="close-nav">
                <img src="/img/icons/close.svg" class="w-full" alt="Menu Icon">
            </main-nav-toggle>
        </div>

        <nav class="flex content-center items-center justify-center h-screen text-center -mt-10">
            <transition-group
                tag="ul"
                v-bind:css="false"
                v-on:enter="enterItem"
                v-on:leave="leaveItem"
                ref="menuItems"
                appear
            >
            <li key="about" data-index="1">
                <a href="/about-me" class="block py-2 font-title text-2xl">About Me</a>
            </li>
            <li key="processses" data-index="2">
                <a href="/processes-supplies" class="block py-2 font-title text-2xl">My Process &amp; Supplies</a>
            </li>
            <li key="portfolio" data-index="3">
                <a href="/portfolio" class="block py-2 font-title text-2xl">Portfolio</a>
            </li>
            <li key="journal" data-index="4">
                <a href="/journal" class="block py-2 font-title text-2xl">Weekly Update</a>
            </li>
            <li key="shop" data-index="5">
                <a href="/shop" class="block py-2 font-title text-2xl">Shop</a>
            </li>
            <li key="get-in-touch" data-index="6">
                <a href="/get-in-touch" class="block py-2 font-title text-2xl">Get in touch</a>
            </li>
            </transition-group>
        </nav>
    </div>
    </transition>
</template>

<script>
    import { tween, styler, delay, easing, keyframes, spring } from 'popmotion';

    export default {
        computed: {
            show() {
                return this.$root.$data.showNav;
            }
        },
        methods: {
            enterMain: function(el, done) {
                const container = styler(el);
                tween({
                    from: 0,
                    to: 1,
                    duration: 150,
                }).start({
                    update: (v) => {
                        container.set('opacity', v);
                    },
                    complete: () => done()
                });
            },
            leaveMain: function(el, done) {
                const container = styler(el);
                tween({
                    from: 1,
                    to: 0,
                    duration: 250,
                }).start({
                    update: (v) => {
                        container.set('opacity', v);
                    },
                    complete: () => done()
                });
            },
            enterItem: function (el, done) {
                const item = styler(el);
                var delayTime = el.dataset.index * 50;

                item.set('opacity', 0);

                delay(delayTime).start({
                    complete: () => {
                    spring({
                        from: {
                            opacity: 0,
                            'y': 50,
                        },
                        to: {
                            opacity: 1,
                            'y': 0
                        },
                        stiffness: 200,
                        damping: 20
                    }).start({
                        update: ({opacity, y}) => {
                            item.set('y', y);
                            item.set('opacity', opacity);
                        },
                        complete: v => done
                    })
                    }
                })
            },
            leaveItem: function (el, done) {
                const item = styler(el);
                var delayTime = el.dataset.index * 50;

                delay(delayTime).start({
                    complete: () => {
                        spring({
                            from: {
                                opacity: 1,
                                'y': 0,
                            },
                            to: {
                                opacity: 0,
                                'y': 50
                            },
                            stiffness: 200,
                            damping: 20
                        }).start({
                            update: ({opacity, y}) => {
                                item.set('y', y);
                                item.set('opacity', opacity);
                            },
                            complete: v => done
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>